export default "__VITE_ASSET__DFn4VX6N__"